import { FC, HTMLAttributes } from "react";
// import { Image } from "@onmo/ui";
import clsx from "classnames";
import { useQuery } from "@apollo/client";
import { filter } from "lodash-es";
import { gamesGQL, GameStatus, GameType } from "@onmo/graphql/graphql";
import { GuideWinGems } from "../GuideWinGems";
import { ContinuePlay } from "../ContinuePlay";
import RankCard from "../../core/RankCard/RankCard";
import RankCardLoading from "../../core/RankCard/RankCardLoading";
import { useStyles } from "./HowToWinTab.style";
import { useRankInfo } from "../../../hooks/useRankInfo";
import { useTranslation } from "react-i18next";

interface HowToWinTabProps {
  rank: number;
  score: number;
  username: string;
  avatar: string;
}

const isHtmlGame = (gameType?: GameType) => {
  return (
    gameType === GameType.Html ||
    gameType === GameType.DirectHtml ||
    gameType === GameType.IframeHtml
  );
};

export const HowToWinTab: FC<
  HowToWinTabProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { rank, score, username, avatar, className, ...otherProps } = props;
  const { t } = useTranslation();
  const { data } = useQuery(gamesGQL, {
    variables: {
      input: { status: GameStatus.Live },
    },
  });

  const games = filter(data?.games?.items || [], (item) =>
    isHtmlGame(item.type),
  ).slice(0, 10);

  const { newRankWithState } = useRankInfo({
    rank: rank,
    type: "allTime",
  });

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      {/* <Image
        src="https://ecacdn.challengesarena.com/images/leaderboard/5430627940279189504_1750138321997.png"
        className={classes.banner}
      /> */}
      {rank > 0 && (
        <RankCard
          rank={rank + 1}
          username={username}
          reward={score}
          avatar={avatar}
          myRank
          className={classes.rankCard}
          rankState={newRankWithState?.rankState}
        />
      )}
      <GuideWinGems className={clsx(games?.length && classes.guide)} />
      <ContinuePlay
        isPlayAndWin
        label={t("play_and_win")}
        className={classes.playWin}
        games={games}
      />
    </div>
  );
};
